import React, { useEffect, useState } from 'react'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import PropTypes from 'prop-types';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';
import PopupHeader from 'Components/PopupHeader/PopupHeader';
import PopupFooter from 'Components/PopupFooter/PopupFooter';
import Skeleton from 'Components/skeleton/Skeleton';

//  this is a popup template to make any poup use this template
const ViewItemizedReportPopup = ({ onClose,url, disableDraggable }) => {
    const [loading, setLoading] = useState(true);
    const uniqueId = "ViewItemizedReportPopup"


    return (
        <ReactPortal wrapperId={uniqueId}>
            <div data-te-modal-init className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75" id="exampleModalScrollable" tabIndex={-1} aria-labelledby="exampleModalScrollableLabel" aria-modal="true" data-te-open="true">
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div data-te-modal-dialog-ref className="relative w-[900px]   min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg">
                        <div className='p-10 pt-0 '>
                            <PopupHeader uniqueId={uniqueId} heading='Patient Itemized Report' />
                            <div className="flex flex-col overflow-hidden max-h-[70vh]">    
                                <div className="flex-1">
                                    {loading && <Skeleton extraClass="w-full h-[900px] border-0"/>}
                                    <iframe
                                        src={`${url}#toolbar=1`}
                                        title={`ItemizedReport-${uniqueId}-${url}`}
                                        className="w-full h-[900px] border-0"
                                        onLoad={() => setLoading(false)}
                                        />
                                </div>
                            </div>

                            <PopupFooter onClose={onClose} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default ViewItemizedReportPopup

ViewItemizedReportPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
};


// Some Time Saving Functions to use in whole project

// const handleChange = (e) => {
//     let { name, value, checked, type } = e.target
//     setnotesModel((prevState) => ({ ...prevState, [name]: type === 'checkbox' ? !checked : value, }));
//}


